<script setup lang="ts">
import { ref } from 'vue';

const { locales, setLocale, locale } = useI18n();
const selectedLocale = ref(locale.value && locales.value.find((l) => l.code === locale.value)?.code);
const currentAvatar = computed(() => {
  const foundLocale = locales.value.find((l) => l.code === selectedLocale.value);
  return (
    foundLocale?.avatar || {
      src: '/flags/en-US.png',
      alt: 'English (United States)'
    }
  );
});
</script>

<template>
  <div>
    <USelect
      v-model="selectedLocale"
      size="md"
      :items="
        locales.map((l) => ({
          value: l.code,
          avatar: l.avatar as any
        }))
      "
      :avatar="currentAvatar"
      variant="ghost"
      @change="selectedLocale && setLocale(selectedLocale)"
    />
  </div>
</template>
